import React from "react";
import Filter from "./Filter";
import RegionFilter from "./RegionFilter";
import styles from "./Header.module.css";

function Header({ viewMode, setViewMode, onChange, onRegionChange }) {
  return (
    <div className={styles.headerContainer}>
      {/* ORQID CLUB Title */}
      <div className={styles.titleContainer}>
        <a href="https://orqidclub.com" target="_blank" rel="noopener noreferrer" className={styles.title}>
          ORQID CLUB
        </a>
      </div>

      {/* Filters */}
      <div className={styles.filters}>
        <Filter onChange={onChange} />
        <RegionFilter onRegionChange={onRegionChange} />
      </div>
    </div>
  );
}

export default Header;
